import _ from "lodash";
import React from "react";
import { colors } from "Constants";
import classes from "./CustomProgressSteps.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import { onEnterOrSpaceKeyDown } from "Utils";

// steps is an array of object
/**
 * steps = {
 *  id,
 *  label
 * }
 */

const CustomProgressSteps = ({
  steps,
  currentStep,
  onClick,
  borderWidth = 4,
  shouldDisplayLabel,
  testId = "UIComponents",
}) => {
  const handleClick = stepId => {
    if (onClick) {
      onClick({ step: stepId });
    }
  };
  return (
    <div className={classes.progressBarContainer}>
      {_.map(steps, step => {
        const backgroundColor =
          currentStep == step?.id ? colors.borderActive : colors.borderSubtle;
        const labelStyles = classNames(
          {
            [classes.labelContainer]: true,
          },
          {
            "text-body-2": true,
          }
        );
        const progressBarStyles = classNames(
          { [classes.progressBar]: true },
          { [classes.fullScreenProgressBar]: shouldDisplayLabel }
        );
        return (
          <button
            key={step?.id}
            className={progressBarStyles}
            data-test-id={`${testId}-customProgressSteps-step-${step?.id}`}
            style={{
              borderBottom: `${borderWidth}px solid ${backgroundColor}`,
            }}
            onClick={() => handleClick(step?.id)}
            tabIndex={0}
            onKeyDown={e => {
              onEnterOrSpaceKeyDown(e, () => handleClick(step?.id));
            }}
          >
            {shouldDisplayLabel ? (
              <div className={labelStyles}>{step?.label}</div>
            ) : null}
          </button>
        );
      })}
    </div>
  );
};

CustomProgressSteps.defaultProps = {
  shouldDisplayLabel: true,
  testId: "UIComponent",
};

CustomProgressSteps.propTypes = {
  testId: PropTypes.string,
  steps: PropTypes.array,
  currentStep: PropTypes.string,
  onClick: PropTypes.func,
  borderWidth: PropTypes.number,
  shouldDisplayLabel: PropTypes.bool,
};

export default CustomProgressSteps;
